// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal {
  display: flex;
  align-items: center; }
  .modal__note {
    margin-top: 10px;
    font-size: 16px; }
  .modal__icon, .modal__text,
  .modal span {
    color: #ff0000;
    font-size: 14px;
    margin-right: 10px; }
  .modal__content {
    margin-bottom: 20px;
    font-size: 18px; }
  .modal__confirm-btn {
    color: white;
    padding: 10px 12px;
    border-radius: 5px;
    cursor: pointer;
    border: none;
    width: 150px;
    margin-right: 15px;
    font-size: 16px;
    font-weight: bold;
    transition: background-color 0.3s ease; }
    .modal__confirm-btn:hover {
      color: white; }
  .modal__btns-wrapper {
    display: flex;
    justify-content: center; }
    .modal__btns-wrapper button {
      margin: 0 10px; }
  .modal__cancel-btn {
    background-color: #ff0000;
    color: white;
    padding: 10px 12px;
    border-radius: 5px;
    border: none;
    width: 150px;
    font-size: 16px;
    font-weight: bold;
    transition: background-color 0.3s ease; }
    .modal__cancel-btn:hover {
      color: white; }
`, "",{"version":3,"sources":["webpack://./src/components/Modal/style.scss","webpack://./src/styles/variables/_variables.scss"],"names":[],"mappings":"AAEA;EACI,aAAa;EACb,mBAAmB,EAAA;EAEnB;IACI,gBAAgB;IAChB,eAAe,EAAA;EAGnB;;IAGI,cCJkB;IDKlB,eAAe;IACf,kBAAkB,EAAA;EAGtB;IACI,mBAAmB;IACnB,eAAe,EAAA;EAGnB;IACI,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,sCAAsC,EAAA;IAVzC;MAac,YAAY,EAAA;EAI3B;IACI,aAAa;IACb,uBAAuB,EAAA;IAF1B;MAKO,cAAc,EAAA;EAItB;IACI,yBCzCkB;ID0ClB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,sCAAsC,EAAA;IATzC;MAYO,YAAY,EAAA","sourcesContent":["@import \"../../styles/variables/variables\";\n\n.modal {\n    display: flex;\n    align-items: center;\n\n    &__note {\n        margin-top: 10px;\n        font-size: 16px;\n    }\n\n    &__icon,\n    &__text,\n    span {\n        color: $tokenErrorStatus;\n        font-size: 14px;\n        margin-right: 10px;\n    }\n\n    &__content {\n        margin-bottom: 20px;\n        font-size: 18px;\n    }\n\n    &__confirm-btn {\n        color: white;\n        padding: 10px 12px;\n        border-radius: 5px;\n        cursor: pointer;\n        border: none;\n        width: 150px;\n        margin-right: 15px;\n        font-size: 16px;\n        font-weight: bold;\n        transition: background-color 0.3s ease;\n\n        &:hover {\n                   color: white;\n        }\n    }\n\n    &__btns-wrapper {\n        display: flex;\n        justify-content: center;\n\n        button {\n            margin: 0 10px;\n        }\n    }\n\n    &__cancel-btn {\n        background-color: $tokenErrorStatus;\n        color: white;\n        padding: 10px 12px;\n        border-radius: 5px;\n        border: none;\n        width: 150px;\n        font-size: 16px;\n        font-weight: bold;\n        transition: background-color 0.3s ease;\n\n        &:hover {\n            color: white;\n        }\n    }\n}\n","// Main Colors\n$tokenBackgroundColor: #2b074d;\n$tokenContainerBackgroundColor: rgba($tokenBackgroundColor, 0.85);\n$tokenWhiteColor: #ffffff;\n$tokenBlackColor: #000000;\n$tokenPlaceholderColor: #757179;\n\n// Status Colors\n$tokenVerifyStatus: #60ffa8;\n$tokenPendingStatus: #ffdb81;\n$tokenErrorStatus: #ff0000;\n\n// SHADOW\n$tokenContainerShadow: 0 0 14px 0 #ff2481;\n\n// BORDER\n$tokenContainerRadius: 20px;\n$tokenContainerBorderColor: #340c5a;\n\n// BUTTON\n$tokenButtonBorderColor: #e02574;\n$tokenButtonBackgroundColor: #ff2481;\n$tokenButtonHoverColor: #e02574;\n\n// COIN BACKGROUND\n$tokenCoinBackground: #ededed;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
